import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import MatchCreateForm from './MatchCreateForm';
import { SectionHeader, SectionContent, Card, ZeroState } from '../../components/chrome';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
	toolbarTitle: {
		marginBottom: 20
	}
});

class MatchEdit extends Component {
	handleAfterSubmit = slug => {
		const { history } = this.props;
	};

	render() {
		const { classes } = this.props;

		return (
			<SectionHeader title="Edit Match" backButton={true} backPath={`/matches/${this.props.match.params.id}`}>
				<div style={{ marginTop: 24, marginBottom: 24 }}>
					<Grid container justify="center" spacing={24}>
						<Grid item xs={12} md={11} lg={10}>
							<Grid container justify="center" spacing={24}>
								<Grid item xs={12}>
									<Card>
										<Typography variant="h6" color="inherit" className={classes.toolbarTitle}>
											<span>Match Details</span>
										</Typography>
										<MatchCreateForm id={this.props.match.params.id} />
									</Card>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</div>
			</SectionHeader>
		);
	}
}

MatchEdit.propTypes = {
	classes: PropTypes.object.isRequired
};

export default withStyles(styles)(MatchEdit);
